export const dateFormat = str => {
  if (str) {
    let [day, month, year] = str.split('.');
    return new Date(`${year}-${month}-${day}T00:00:00-03:00`);
  }
};
